import Position from './position';

export default class CollisionBounds {
	
	constructor(args={}) {
		this.t = args.t || 0;
		this.r = args.r || 0;
		this.b = args.b || 0;
		this.l = args.l || 0;
		this.cx = args.cx || 0;
		this.cy = args.cy || 0;
		this.radius = args.radius || 0;
	}

	/**
	 * @param {CollisionBounds} a 
	 * @param {CollisionBounds} b 
	 * @returns {Boolean}
	 */
	static intersectingRects(a,b) {
		return a.l < b.r && a.r > b.l && a.t < b.b && a.b > b.t;
	}

	/**
	 * @param {Position} p 
	 * @param {CollisionBounds} r 
	 * @returns {Boolean}
	 */
	static positionWithinRect(p,r) {
		return p.y > r.t && p.y < r.b && p.x > r.l && p.x < r.r;
	}

	/**
	 * @param {CollisionBounds} a 
	 * @param {CollisionBounds} b 
	 * @returns {Boolean}
	 */
	static intersectingCircles(a,b) {
		let dx = b.cx - a.cx;
		let dy = b.cy - a.cy;
		return Math.hypot(dx, dy) - a.radius - b.radius < 0;
	}

	/**
	 * @param {Position} p 
	 * @param {CollisionBounds} c 
	 * @returns {Boolean}
	 */
	static positionWithinCircle(p,c) {
		let dx = p.x - c.cx;
		let dy = p.y - c.cy;
		return Math.hypot(dx, dy) < c.radius;
	}

}